import React, { useState } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import useDataFlights from '../../../../../dataHooks/useDataFlights'

export default ({
  flightData = {},
  eventId,
  onClose,
  onSuccess,
}) => {

  const { Departing: departingFlightData, Returning: returningFlightData } = flightData;

  let isRoundTrip = false;
  if (departingFlightData && returningFlightData) {
    isRoundTrip = true;
  }

  const {
    deleteFlight,
  } = useDataFlights()

  const [isBusy, setIsBusy] = useState(false);

  const onClickSubmit = async () => {
    if (!isBusy) {
      setIsBusy(true)

      try {
        if (departingFlightData) {
          await deleteFlight(departingFlightData)
        }
        if (returningFlightData) {
          await deleteFlight(returningFlightData)
        }

        setIsBusy(false)

        onSuccess()
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Confirm'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Delete Flight'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <div>{'Are you sure you wish to delete this flight?'}</div>
        {
          isRoundTrip &&
          <div style={{ fontStyle: 'italic', marginTop: '30px' }}>{'*This flight is a roundtrip, so this action will delete both the departing and returning flight.'}</div>
        }
      </div>
    </Modal>
  )
}